import {
  getUser,
  urlParams,
  wrappedGet,
  wrappedPost,
} from "@sourcewhale/shared/src/assets/js/src/general/utils";

let trainingProgress = [];

const tasks = {
  start: [
    {
      id: "download-chrome-extension",
      title: "Download Chrome extension",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Quick Start Guide/Downloading the extension.mp4",
      modalButton: {
        title: "Download",
        link: "https://chrome.google.com/webstore/detail/sourcewhale/hfnnombjdnokggcepagcndckmngedifk",
      },
      estimatedTime: 2,
      icon: "fa-cloud-arrow-down",
    },
    {
      id: "set-up-signature",
      title: "Set up signature",
      url: "/profile",
      estimatedTime: 2,
      icon: "fa-signature",
    },
    {
      id: "understand-the-dashboard",
      title: "Understand the dashboard",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Login and Setup/Understanding the dashboard.mp4",
      modalButton: {
        title: "Dashboard",
        link: "/dashboard",
      },
      estimatedTime: 5,
      icon: "fa-grid-2",
      clickToComplete: true,
    },
  ],
  messages: [
    {
      id: "multi-step-campaign",
      title: "Create first multi-step campaign",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Campaigns/Creating a campaign.mp4",
      modalButton: {
        title: "Campaigns",
        link: "/campaigns",
      },
      estimatedTime: 5,
      icon: "fa-bullhorn",
    },
    {
      id: "navigate-campaign-settings",
      title: "Navigate the campaign settings",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Campaigns/Navigating the campaign settings.mp4",
      modalButton: {
        title: "Campaigns",
        link: "/campaigns",
      },
      estimatedTime: 5,
      icon: "fa-gear",
    },
    {
      id: "add-contacts-to-campaign-single-profile",
      title: "Add contacts to a campaign from LinkedIn (Single-Profile)",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Adding Contacts/Add a contact to a campaign from LinkedIn.mp4",
      estimatedTime: 2,
      icon: "fa-user",
    },
    {
      id: "add-contacts-to-campaign-multi-profile",
      title: "Add contacts to a campaign from LinkedIn (Multi-Profile)",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Adding Contacts/Add multiple contacts to a campaign from LinkedIn.mp4",
      estimatedTime: 2,
      icon: "fa-users",
    },
    {
      id: "upload-spreadsheet",
      title: "Uploading a spreadsheet to SourceWhale",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Spreadsheet Upload/Uploading a spreadsheet.mp4",
      modalButton: {
        title: "Spreadsheet Upload",
        link: "/upload",
      },
      estimatedTime: 5,
      icon: "fa-file-spreadsheet",
    },
  ],
  success: [
    {
      id: "best-practices-1",
      title:
        "Best Practices #1: Automated vs. Manual Steps & Multi-Channel Outreach",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Best Practices/1. Automated vs manual steps, and multi-channel outreach.mp4",
      estimatedTime: 2,
      icon: "fa-medal",
      clickToComplete: true,
    },
    {
      id: "best-practices-2",
      title: "Best Practices #2: Subject Lines, Variables, and Content Length",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Best Practices/2. Subject lines, variables, and content length.mp4",
      estimatedTime: 3,
      icon: "fa-medal",
      clickToComplete: true,
    },
    {
      id: "best-practices-3",
      title:
        "Best Practices #3: Finding Value, Breaking Down Information, & Call to Actions",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Best Practices/3. Finding value, breakdown information, and call to action.mp4",
      estimatedTime: 2,
      icon: "fa-medal",
      clickToComplete: true,
    },
    {
      id: "best-practices-4",
      title: "Best Practices #4: Follow-Ups & Custom Images",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/Best Practices/4. Follow-ups and custom images.mp4",
      estimatedTime: 1,
      icon: "fa-medal",
      clickToComplete: true,
    },
    {
      id: "navigating-todos-page",
      title: "Navigating the To-Dos page",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/To-Dos Page/Navigating the To-Dos page.mp4",
      modalButton: {
        title: "To-Dos",
        link: "/todo",
      },
      estimatedTime: 2,
      icon: "fa-check-square",
    },
    {
      id: "actioning-linkedin-requests",
      title: "Actioning LinkedIn Connection Requests",
      videoSrc:
        "https://www.sourcewhale.app/training-videos/To-Dos Page/Actioning LinkedIn Connection Requests.mp4",
      modalButton: {
        title: "To-Dos",
        link: "/todo",
      },
      estimatedTime: 2,
      icon: "fa-check-square",
    },
    {
      id: "visit-help-centre",
      title: "Visit help centre",
      url: "https://help.sourcewhale.app/en/",
      estimatedTime: 1,
      icon: "fa-square-info",
      clickToComplete: true,
    },
  ],
  liveTraining: [
    {
      id: "starter-workshop",
      title: "New Starter Workshop - Session 1",
      externalUrl:
        "https://sourcewhale.zoom.us/webinar/register/WN_aJvSkh0gRP2qbSvw6enDVQ",
      estimatedTime: 1,
      icon: "fa-medal",
      subText:
        "In this 45 minute session we will be covering the fundamentals of creating your first campaigns, showing you how to use industry insights to craft compelling content and utilise key SourceWhale features like Content Coach and WhaleGPT. Additionally you will learn how to use the SourceWhale extension to add contacts to your campaign so you're ready to go!",
    },
    {
      id: "acceleration-workshop",
      title: "Acceleration Workshop - Session 2",
      externalUrl:
        "https://sourcewhale.zoom.us/webinar/register/WN_NSmzUNj9QIC9KY0C5cTQuA",
      estimatedTime: 1,
      icon: "fa-medal",
      subText:
        "In this 45 minute Acceleration Session, we will explore industry-leading tips to maximize engagement with clients and candidates through effective outreach. We will also discuss the utilization of a multi-channel approach, which includes phone calls and LinkedIn campaigns. Please make sure to attend the New Starter Workshop before participating in this session.",
    },
  ],
};

const categories = [
  {
    id: "start",
    title: "Your quick start guide",
    tasks: tasks.start,
  },
  {
    id: "messages",
    title: "Deliver personalised messages at scale",
    tasks: tasks.messages,
  },
  {
    id: "success",
    title: "Get set up for success",
    tasks: tasks.success,
  },
  {
    id: "liveTraining",
    title: "Register for Live Training",
    tasks: tasks.liveTraining,
  },
];

const params = Object.fromEntries(urlParams.entries());

const updateRemainingTasks = () => {
  categories.forEach((category) => {
    const nTotalTasks = category.tasks.length;
    const nCompletedTasks = category.tasks.filter((task) =>
      trainingProgress.includes(task.id),
    ).length;
    const nRemainingTasks = nTotalTasks - nCompletedTasks;

    $(`#${category.id}-item .remaining`).html(
      `${nRemainingTasks} task${nRemainingTasks === 1 ? "" : "s"} remaining`,
    );
    if (nRemainingTasks === 0) $(`#${category.id}-item`).addClass("completed");

    const estimatedTime = category.tasks
      .filter((x) => !trainingProgress.includes(x.id))
      .reduce((acc, task) => acc + task.estimatedTime, 0);
    $(`#${category.id}-item .task-estimated-time`).html(
      `About ${estimatedTime} min${estimatedTime === 1 ? "" : "s"}`,
    );
  });
};

const updateUserTrainingProgress = () => {
  const { userId } = getUser();

  const updateTask = (taskId, req) => {
    if (trainingProgress.includes(taskId) || !req) return;

    $(`#${taskId}`).addClass("completed");
    trainingProgress = [...trainingProgress, taskId];

    const data = {
      userId: getUser().userId,
      updates: {
        trainingProgress,
      },
    };

    wrappedPost({
      url: "/api/users/save",
      data: JSON.stringify(data),
      success: () => updateRemainingTasks(),
    });
  };

  const updateTasks = (user) => {
    updateTask("download-chrome-extension", user.extensionVersion);
    updateTask("set-up-signature", user.signature);
    updateTask("upload-spreadsheet", user.hasUploadedSpreadsheet);
    updateTask("navigating-todos-page", user.hasVisitedTodos);
    updateTask("understand-the-dashboard", user.hasVisitedDashboard);
    updateTask("navigate-campaign-settings", user.hasVisitedCampaignSettings);
    updateTask(
      "add-contacts-to-campaign-single-profile",
      user.addedSingleProfileFromExtension,
    );
    updateTask(
      "add-contacts-to-campaign-multi-profile",
      user.addedMultiProfileFromExtension,
    );
    updateTask(
      "actioning-linkedin-requests",
      user.linkedInConnectionRequestDone,
    );

    if (
      !trainingProgress.includes("integration-setup") ||
      !trainingProgress.includes("sync-settings")
    ) {
      wrappedGet({
        url: "/api/integrations/get_all",
        success: (integrations) => {
          updateTask("integration-setup", Object.keys(integrations).length > 0);

          Object.values(integrations).some((integration) => {
            if (integration.modified) {
              updateTask("sync-settings", true);
              return true;
            }
            return false;
          });
        },
      });
    }

    if (!trainingProgress.includes("multi-step-campaign")) {
      wrappedGet({
        url: "/api/campaigns/get_open",
        success: (campaigns) => {
          campaigns = campaigns.filter(
            (campaign) => campaign.creatorUserId === userId,
          );

          if (!campaigns.length) return;

          let i = 0;

          const callback = (campaignId) => {
            wrappedGet({
              url: "/api/campaigns/get_overview",
              data: { campaignId },
              success: (overview) => {
                const nSteps = Object.values(
                  overview.campaign.templates,
                ).length;
                if (nSteps > 1) {
                  updateTask("multi-step-campaign", true);
                } else if (campaigns[i + 1]) {
                  i += 1;
                  callback(campaigns[i].campaignId);
                }
              },
            });
          };

          callback(campaigns[i].campaignId);
        },
      });
    }
  };

  wrappedGet({
    url: "/api/users/get",
    data: { userId },
    success: (res) => updateTasks(res),
  });
};

const addCategory = (id, opts) => {
  $("#category-grid").append(/* html */ `
      <div id="${id}-item" class="category">
        <div class="bg-icons-container">
          <div class="bg-icon"></div>
          <div class="bg-icon"></div>
          <div class="bg-icon"></div>
          <div class="bg-icon"></div>
          <div class="bg-icon"></div>
        </div>
        <div class="completed-tick">
          <i class="fa-solid fa-check"></i>
        </div>
        <div class="category-header">
          <div class="left">
            <div class="main-icon-container"></div>
          </div>
          <div class="right">
            <div class="category-title">${opts.title}</div>
            <div class="category-tasks">
              <div class="remaining"></div>
              <div class="circle"></div>
              <div class="task-estimated-time"></div>
            </div>
            <div class="completed-badge badge badge-success">Completed</div>
          </div>
        </div>
      </div>
    `);

  updateRemainingTasks();

  $(`#${id}-item`).append(/* html */ `
      <div id="${id}-tasks-container" class="category-tasks-container"></div>
    `);

  opts.tasks.forEach((task) => {
    const taskCompletedClass = trainingProgress.includes(task.id)
      ? "completed"
      : "";
    const taskTypeIcon = task.videoSrc
      ? "fa-circle-play"
      : "fa-square-up-right";

    $(`#${id}-tasks-container`).append(/* html */ `
        <a id="${task.id}" class="task-item-wrapper">
          <div class="task-item ${taskCompletedClass}" data-video-src="${
            task.videoSrc
          }" target="_blank">
            <div class="left">
              <div class="task-icon-container">
                <i class="task-icon fa-light fa-fw ${task.icon}"></i>
                <div class="task-completed-tick">
                  <i class="fa-solid fa-check"></i>
                </div>
              </div>
              <p>${task.title}</p>
              <i class="icon fa-regular ${taskTypeIcon}"></i>
            </div>
            <div class="right">
              <div class="estimated-time">${task.estimatedTime} min${
                task.estimatedTime === 1 ? "" : "s"
              }</div>
              <div class="completed-badge">Completed</div>
            </div>
          </div>
          ${
            task.subText
              ? `<div class="sub-text"><p>${task.subText}</p></div>`
              : ""
          }
        </a>
      `);

    if (task.url) $(`#${task.id}`).attr("href", task.url);

    if (task.externalUrl)
      $(`#${task.id}`).attr("href", task.externalUrl).attr("target", "_blank");

    $(`#${task.id}`).on("click", (e) => {
      if (task.videoSrc) {
        $("#training-video-modal").modal("show");
        $("#training-video-modal-title").html(task.title);

        const videoSrc = $(e.currentTarget)
          .find(".task-item")
          .first()
          .data("video-src");
        const video = $("#training-video")[0];
        video.src = videoSrc;
        video.load();
        video.play();

        $("#training-video-modal-button").addClass("d-none");

        if (task.modalButton) {
          $("#training-video-modal-button").removeClass("d-none");
          $("#training-video-modal-button span").html(task.modalButton.title);
          $("#training-video-modal-button").attr("href", task.modalButton.link);
        }

        $("#training-video-modal-button").click(() => {
          video.pause();
        });

        $("#training-video-modal").on("hidden.bs.modal", () => {
          video.pause();
        });
      }

      if (task.clickToComplete && taskCompletedClass !== "completed") {
        trainingProgress = [...trainingProgress, task.id];

        $(`#${task.id}`).addClass("completed");
        updateRemainingTasks();

        const data = {
          userId: getUser().userId,
          updates: {
            trainingProgress,
          },
        };

        wrappedPost({
          url: "/api/users/save",
          data: JSON.stringify(data),
        });
      }
    });
  });
};

export const initializeTraining = () => {
  if (params.firstTime) {
    const firstName = getUser().name.split(" ")[0];
    $("#title").html(`Welcome to SourceWhale, ${firstName} 👋`);
  } else {
    $("#title").html("SourceWhale Training");
  }

  $(document).on("click", ".category", (e) => {
    if ($(e.target).hasClass("expanded")) {
      $(e.target).removeClass("expanded");
      return;
    }

    $(".category").removeClass("expanded");
    $(e.currentTarget).addClass("expanded");
  });

  $("#main-container").click((e) => {
    if (e.target !== e.currentTarget) return;
    $(".category").removeClass("expanded");
  });

  $("#training-video-modal").on("hidden.bs.modal", () => {
    updateUserTrainingProgress();
  });

  wrappedGet({
    url: "/api/users/get",
    data: { userId: getUser().userId },
    success: (res) => {
      trainingProgress = res.trainingProgress || [];
      $(".skeleton-category").hide();
      updateUserTrainingProgress();

      categories.forEach((category) => {
        addCategory(category.id, {
          title: category.title,
          tasks: category.tasks,
        });
      });
    },
  });
};
